export const PoolType = {
  PrimaryIssue: "PrimaryIssue",
  SecondaryIssue: "SecondaryIssue",
  MarginIssue: "MarginIssue",
};
